import { Person } from "./person.model";

export class Driver extends Person {
    id?: number;
    documentNumber?: string;
    birthDate?: Date;
    enterprise?: number;
    routes?: any[];
}